









import {Vue, Component, Model, Prop} from 'vue-property-decorator';
@Component
export default class CompSelectBox extends Vue {
  @Prop({default: 'PARTNER_PARTNER_LIST_CHOOSE'}) private needAllText!: string;
  @Prop({default: false}) private needAll!: boolean;
  @Prop({default: false}) private nonI18nConvert!: boolean;
  @Prop({required: true}) private data!: object;
  @Prop({required: true}) private selectValue!: string | number;
  @Prop({required: true}) private selectKey!: string | number;
  @Prop({required: true}) private selectDisplayName!: string;

  @Model('change') readonly value!: any;
  get selectedValue() {
    return this.value;
  }
  set selectedValue(val) {
    this.$emit('change', val);
  }
}
